export default "__VITE_ASSET__8846ed58__"